import axios from "axios";
import _ from "lodash";
import config from "../config";

export default class LeadService {
  static registerLead(stateName, mobile, remarks) {
    return axios.post(`${config.leadServiceUrl}`, {
      state: _.startCase(stateName),
      source: "GL_PWA",
      customerPhoneNumber: mobile,
      skuCode: "AGS-SC-159",
      skuName: "AgroStar Gold Service Live Combo 2 (6 Months)",
      remarks: remarks,
    });
  }

  static registerLeadDelayed(stateName, mobile, remarks) {
    return axios.post(`${config.baseUrl}/lead/register`, {
      state: _.startCase(stateName),
      source: "GL_PWA",
      customerPhoneNumber: mobile,
      skuCode: "AGS-SC-159",
      skuName: "AgroStar Gold Service Live Combo 2 (6 Months)",
      remarks: remarks,
    });
  }

  static getProductsListBySKUs(skus) {
    let stateCodesMap = {
      maharashtra: "MH",
      gujarat: "GJ",
      rajasthan: "RJ",
      "madhya pradesh": "MP",
      "uttar pradesh": "UP",
    };
    return axios.get(
      `${config.farmerappbackendUrl}shopaggregator/v1/products?language=en&sku=${skus}`,
      {
        headers: {
          "X-Authorization-Token": `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImtpZCI6IlMwIn0.eyJzdWIiOjI0NTc5MTUsInB3ZCI6InBia2RmMl9zaGEyNTYkMjAwMDAkYzdNNXlkY0dRWXdtJG9rSGpkaTEyTzZ1aWx6U1VLc1JyeHRMUXl1bk10K1NxS2xkb0FXcGhFN2s9IiwiaWF0IjoxNjQwNjc4NzUzLCJleHBhdCI6bnVsbCwidHlwIjoiUzJTIiwiZ3JwIjpbIkFQUE1IIiwiQVBQUkoiLCJBUFBNUCIsIkFQUEtBIiwiQVBQVE4iLCJ3ZWJfdXNlciJdfQ.hhBRM51hsV6m03-OoIW94ae3WFl_VQLXRwoJdTU-4pk`,
          source: `APP${stateCodesMap[localStorage.getItem(`state`)]}`,
        },
      }
    );
  }
}
